export enum EAgroservicesProductId {
  YOU_DO = 'youdo',
  EFIS_ZSN = 'efis_zsn',
}
